import { Component, Input, EventEmitter, Output, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Item } from './model/item.class';
import { SubItem } from './model/sub-item.class';
import * as _ from 'lodash';

@Component({
  selector: 'app-listbox',
  templateUrl: './listbox.component.html',
  styleUrls: ['./listbox.component.css']
})
export class ListboxComponent {
  @Input() listOne: Item[] = [];
  @Input() listTwo: Item[] = [];
  @Output() listOneChanged = new EventEmitter<Item[]>();
  @Output() listTwoChanged = new EventEmitter<Item[]>();

  selectedItemsListOne: Item | null = null;
  selectedItemsListTwo: Item | null = null;

  selectedItem: Item | null = null;
  selectedSubItem: SubItem | null = null;
  selectedItemListNumber: number | null = null;

  draggedSubItem: SubItem | null = null;

  filterTextOne: string = '';
  filterTextTwo: string = '';
  baseList: Item[] = [];
  filteredListOne: Item[] = [];
  filteredListTwo: Item[] = [];

  filterOneIsActivated: boolean = false;
  filterTwoIsActivated: boolean = false;

  ngOnInit() {
    this.baseList = _.cloneDeep(this.listOne);
    this.filteredListOne = [...this.listOne];
    this.filteredListTwo = [...this.listTwo];
  }

  ngAfterViewInit() {
    // Este método é chamado após o carregamento do view, garantindo que os elementos DOM estejam disponíveis
  }

  adjustTooltipPosition(event: MouseEvent, tooltip: HTMLElement, listNumber: number) {
    const iconRect = (event.target as HTMLElement).getBoundingClientRect();
    const containerRect = (document.querySelector('.listbox-container') as HTMLElement).getBoundingClientRect();
    const tooltipWidth = tooltip.offsetWidth;
    const tooltipHeight = tooltip.offsetHeight;
    const verticalOffset = 10;  // Espaço vertical padrão acima ou abaixo do ícone
  
    // Ajustar a posição vertical
    if (window.innerHeight - iconRect.bottom < tooltipHeight + verticalOffset) {
      tooltip.style.top = 'auto';
      tooltip.style.bottom = `${window.innerHeight - iconRect.top + verticalOffset}px`;
    } else {
      tooltip.style.top = `${iconRect.bottom + verticalOffset}px`;
      tooltip.style.bottom = 'auto';
    }
  
    // Ajustar a posição horizontal dentro dos limites da .listbox-container
    let leftPos = iconRect.left - containerRect.left;  // Posição relativa ao container
  
    if (listNumber === 1) {
      // Para a Lista 1, empurre o tooltip mais para a direita, mas não fora dos limites do container
      leftPos += 140;  // Empurrar mais para a direita
      if (leftPos + tooltipWidth > containerRect.width) {
        leftPos = containerRect.width - tooltipWidth - 20; // Ajusta para não ultrapassar o limite direito
      }
    } else {
      // Para a Lista 2, simplesmente assegure que não ultrapasse os limites
      leftPos += 1000; 
      if (leftPos + tooltipWidth > containerRect.width) {
        leftPos = containerRect.width - tooltipWidth - 20; // Ajusta para não ultrapassar o limite direito
      }
    }
  
    if (leftPos < 0) {
      leftPos = 20;  // Margem mínima do lado esquerdo para ambas as listas
    }
    if (listNumber === 1) {
      tooltip.style.left = `${leftPos}px`;
    } else {
      tooltip.style.left = `${800}px`;
    
    }
  }
  
  showTooltip(event: MouseEvent, tooltip: HTMLElement, listNumber: number) {
    this.adjustTooltipPosition(event, tooltip, listNumber);
    tooltip.style.visibility = 'visible';
    tooltip.style.opacity = '1';
  }
  
  hideTooltip(tooltip: HTMLElement) {
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
  }
  

  sortItemsAlphabetically(list: Item[]) {
    list.sort((a, b) => {
      return a.name.localeCompare(b.name); // Ordena os itens pelo nome em ordem alfabética
    });
  
    // Ordena os subitens de cada item
    list.forEach(item => {
      item.subItens.sort((a, b) => {
        return a.name.localeCompare(b.name); // Ordena os subitens pelo nome em ordem alfabética
      });
    });
  }


  // Métodos de movimento entre listas

  moveItems(fromList: Item[], toList: Item[], originListNumber: number) {
    if (!this.selectedItem) return;

    if (originListNumber === 1 && this.filterTwoIsActivated) this.clearFilterTwo();
    if (originListNumber === 2 && this.filterOneIsActivated) this.clearFilterOne();
  
    if (this.selectedSubItem) {
      // Mover apenas o subitem específico
      let toItem = toList.find(item => item.id === this.selectedItem.id);

      if (!toItem) {
        toItem = this.createNewItem(toList, this.selectedItem);
      }
      if (!toItem.subItens.some(sub => sub.id === this.selectedSubItem.id)) {
        toItem.subItens.push(this.selectedSubItem);
      }
      // Remover o subitem da lista de origem
      const fromItemIndex = fromList.findIndex(item => item.id === this.selectedItem.id);
      if (fromItemIndex !== -1) {
        const fromItem = fromList[fromItemIndex];
        fromItem.subItens = fromItem.subItens.filter(sub => sub !== this.selectedSubItem);
        if (fromItem.subItens.length === 0) {
          fromList.splice(fromItemIndex, 1);
        }
      }

      if (originListNumber === 1) this.addSubItemToListTwo();
    
      if (originListNumber === 2) this.addSubItemToListOne();

    } else {
      
      const newSelectedItem = this.baseList.find(item => item.id === this.selectedItem.id);

      // Remover o item da lista de origem
      const fromItemIndex = fromList.findIndex(item => item.id === this.selectedItem.id);
      
      if (fromItemIndex !== -1) {
        fromList.splice(fromItemIndex, 1);
      }

      const toItemIndex = toList.findIndex(item => item.id === this.selectedItem.id);

      if (toItemIndex !== -1) {
        toList.splice(toItemIndex, 1);
      }

      this.removeItemsListOne(this.selectedItem.id);
      this.removeItemsListTwo(this.selectedItem.id);

      if (originListNumber === 1) this.listTwo.push(newSelectedItem);
      if (originListNumber === 2) this.listOne.push(newSelectedItem);

      toList.push(newSelectedItem);
    }

    this.sortItemsAlphabetically(toList);
    this.sortItemsAlphabetically(fromList);
    this.sortItemsAlphabetically(this.listTwo);
    this.sortItemsAlphabetically(this.listOne);

    this.listOneChanged.emit(this.listOne);
    this.listTwoChanged.emit(this.listTwo);

    this.resetSelection();
  }

  addSubItemToListOne() {
      let toItem = this.listOne.find(item => item.id === this.selectedItem.id);

    if (!toItem) {
        toItem = this.createNewItem(this.listOne, this.selectedItem);
    }
    if (!toItem.subItens.some(sub => sub.id === this.selectedSubItem.id)) {
      toItem.subItens.push(this.selectedSubItem);
    }
    const fromItemIndex = this.listTwo.findIndex(item => item.id === this.selectedItem.id);
    if (fromItemIndex !== -1) {
      const fromItem = this.listTwo[fromItemIndex];
      fromItem.subItens = fromItem.subItens.filter(sub => sub !== this.selectedSubItem);
      if (fromItem.subItens.length === 0) {
        this.listTwo.splice(fromItemIndex, 1);
      }
    }
  }

  addSubItemToListTwo() {
    let toItem = this.listTwo.find(item => item.id === this.selectedItem.id);

  if (!toItem) {
      toItem = this.createNewItem(this.listTwo, this.selectedItem);
  }
  if (!toItem.subItens.some(sub => sub.id === this.selectedSubItem.id)) {
    toItem.subItens.push(this.selectedSubItem);
  }
  const fromItemIndex = this.listOne.findIndex(item => item.id === this.selectedItem.id);
  if (fromItemIndex !== -1) {
    const fromItem = this.listOne[fromItemIndex];
    fromItem.subItens = fromItem.subItens.filter(sub => sub !== this.selectedSubItem);
    if (fromItem.subItens.length === 0) {
      this.listOne.splice(fromItemIndex, 1);
    }
  }
}

  removeItemsListOne(id: number) {
      const fromItemIndex = this.listOne.findIndex(item => item.id === id);
      if (fromItemIndex !== -1) {
        this.listOne.splice(fromItemIndex, 1);
      }
  }

  removeItemsListTwo(id: number) {
    const fromItemIndex = this.listTwo.findIndex(item => item.id === id);
    if (fromItemIndex !== -1) {
      this.listTwo.splice(fromItemIndex, 1);
    }
  }

  removeSubItemListOne(itemId: number, subItemId: SubItem) {
    const fromItemIndex = this.listOne.findIndex(item => item.id === itemId);
      if (fromItemIndex !== -1) {
        const fromItem = this.listOne[fromItemIndex];
        fromItem.subItens = fromItem.subItens.filter(sub => sub !== subItemId);
        if (fromItem.subItens.length === 0) {
          this.listOne.splice(fromItemIndex, 1);
        }
    }
  }

  removeSubItemListTwo(itemId: number, subItemId: SubItem) {
    const fromItemIndex = this.listTwo.findIndex(item => item.id === itemId);
      if (fromItemIndex !== -1) {
        const fromItem = this.listTwo[fromItemIndex];
        fromItem.subItens = fromItem.subItens.filter(sub => sub !== subItemId);
        if (fromItem.subItens.length === 0) {
          this.listTwo.splice(fromItemIndex, 1);
        }
    }
  }

  createNewItem(toList: Item[], item: Item): Item {
    const newItem = { ...item, subItens: [] };
    toList.push(newItem);
    return newItem;
  }

  resetSelection() {
    if (this.selectedItem) {
      this.selectedItem.originList = undefined;
    }
    if (this.selectedSubItem) {
      this.selectedSubItem.originList = undefined;
    }
    this.selectedItem = null;
    this.selectedSubItem = null;
  }

  selectItem(item: Item, listNumber: number) {
    this.resetSelection(); 
    this.selectedItem = item;
    this.selectedItem.originList = listNumber;
  }
  
  selectSubItem(subItem: SubItem, item: Item, listNumber: number, event: MouseEvent) {
    event.stopPropagation();
    this.resetSelection(); // Limpa a seleção anterior
    this.selectedSubItem = subItem;
    this.selectedItem = item;  // Seleciona o item pai
    this.selectedSubItem.originList = listNumber;  // Seleciona a lista de origem
    this.selectedItem.originList = listNumber;  // Garante que o item pai rastreie a mesma origem
  }

  // Métodos de filtro

  filterItems(list: Item[], filter: string): Item[] {
    if (!filter.trim()) {
      return list; // Return the original list if no filter is applied
    }
    const lowerCaseFilter = filter.toLowerCase();
  
    // Filtra itens que correspondam ao termo pesquisado ou que possuam subitens que correspondam ao termo pesquisado.
    return list.filter(item =>
      item.name.toLowerCase().includes(lowerCaseFilter) ||
      item.subItens.some(subItem => subItem.name.toLowerCase().includes(lowerCaseFilter))
    ).map(item => ({
      ...item,
      // Filtra somente subitems que correspondam ao termo pesquisado, se houver algum filtro aplicado.
      subItens: item.subItens.filter(subItem => subItem.name.toLowerCase().includes(lowerCaseFilter))
    }));
  }

  applyFilterOne() {
    this.filterOneIsActivated = true;
    this.filteredListOne = this.filterItems(this.listOne, this.filterTextOne);
  }
  
  applyFilterTwo() {
    this.filterTwoIsActivated = true;
    this.filteredListTwo = this.filterItems(this.listTwo, this.filterTextTwo);
  }

  isItemInList(item: Item, list: Item[]): boolean {
    return list.some(listItem => {
      if (listItem.id === item.id) {
        return true;
      }
      // Verifica também se algum subItem de 'item' está em 'listItem.subItens'
      return item.subItens.some(subItem => listItem.subItens.some(listSubItem => listSubItem.id === subItem.id));
    });
  }

  clearFilterOne() {
    this.filterTextOne = '';
    this.filterOneIsActivated = false;
    this.filteredListOne = this.listOne;// Reaplica o filtro com a lista original completa
  }

  clearFilterTwo() {
    this.filterTextTwo = '';
    this.filterTwoIsActivated = false;
    this.filteredListTwo = this.listTwo; // Reaplica o filtro com a lista original completa
  }
  
}
